/**
 * @param url {string}
 * @param id {string}
 * @returns promise
 * */
export const loadScriptPromise = (url, id) => {
  return new Promise(function (resolve, reject) {
    if (id && document.getElementById(id)) {
      return resolve()
    }
    let s;
    s = document.createElement('script');
    s.src = url;
    s.id = id;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
};
